import { dateFormatters } from '@frontend/duck-tape';
import { useFeatureIsOn } from '@frontend/react';
import { Text, YStack } from '@frontend/web-react';
import { applyClass } from '@frontend/web-utils';

type TaskChatTimeProps = {
  time: DateTimeISOString;
};
export const TaskChatTime = ({ time }: TaskChatTimeProps) => {
  const { enabled: isGameplanPricingEnabled } = useFeatureIsOn('is_gameplan_pricing_enabled');

  return (
    <YStack className={applyClass(!isGameplanPricingEnabled, 'items-center')}>
      <Text color="secondary" type="p-sm">
        {dateFormatters.message(time)}
      </Text>
    </YStack>
  );
};
